import PREVIOUS_SEARCH_COUNT from 'constants/previous-search-count';

export default function TrainsOnewayBaseController(
    $scope,
    $state,
    trainsFactory,
    flightsUtils,
    timeService,
    l10nService,
    cfg
) {
    'ngInject';

            let allSearchesFetched = false;
            $scope.showOptions = trainsFactory.showOptions;

            $scope.flightType = 'oneway';

            $scope.updateArrival = function(isArrival) {
                $scope.params.TicketSearchSegments[0]._isArrivalTime = isArrival;
            };

            $scope.$watch('params.TicketSearchSegments[0]._date', () => {
                departTimeWatcher();
                flightsUtils.refreshReturnedDate.bind($scope.params.TicketSearchSegments);
            });

            function departTimeWatcher() {
                flightsUtils.departureTimeWatcher(
                    $scope.params.TicketSearchSegments[0]._date,
                    $scope.options.time0,
                    $scope.params.TicketSearchSegments[0]._time,
                    $scope.options.time
                );
            }

            /* Time Picker */
            const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.TicketSearchSegments[0]._date);

            function fetchTop() {
                const ONE_WAT_FLIGHT = 0;
                trainsFactory.getTopPreviousSearches(ONE_WAT_FLIGHT)
                    .then(setPreviousSearches);
            }

            function fetchAll() {
                if (allSearchesFetched) {
                    return;
                }

                trainsFactory.getAllPreviousSearches(0)
                    .then(setPreviousSearches)
                    .then(() => allSearchesFetched = true);
            }

            function setPreviousSearches({data}) {
                $scope.previousSearches = data;
            }

            $scope.optionsDepart = {
                placeholder: l10nService.localize('Date'),
                required: true,
                months: 2,
                before: trainsFactory.getMaxBookDate(),
                start: initialDepartDate,
                after: moment().hours() >= _.last($scope.options.time).startHour
                    ? moment()
                    : moment().add({days: -1}),
            };

            $scope.previousSearches = [];
            $scope.maxPreviousSearches = PREVIOUS_SEARCH_COUNT.TOP;

            $scope.allPreviousResultsShown = function() {
                return $scope.maxPreviousSearches === PREVIOUS_SEARCH_COUNT.EXTENDED;
            };

            $scope.togglePreviousSearches = function() {
                fetchAll();
                $scope.maxPreviousSearches = $scope.allPreviousResultsShown()
                    ? PREVIOUS_SEARCH_COUNT.TOP
                    : PREVIOUS_SEARCH_COUNT.EXTENDED;
            };

            $scope.findFlights = function() {
                $scope.params.flightType = 'oneway';
                $scope.params.resetPagination();
                trainsFactory.fetchFlights(angular.copy($scope.params), false,
                    {outbound: $scope.params.TicketSearchSegments[0]._isArrivalTime})
                    .then(() => {
                        $state.go(cfg.resultsRoute);
                    });

            };

            $scope.repeatSearch = function(search, type, options) {
                // set open state of 'more options' panel
                $scope.showOptions = flightsUtils.moreOptionsApplied(search);

                trainsFactory.getSearch(search.Id)
                    .then(function(res) {
                        angular.forEach(res.data.TicketSearchSegments, function(segment, i) {
                            segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                            segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                        });

                        $scope.updateArrival(res.data.TicketSearchSegments[0].DayTimeFilterSource);

                        trainsFactory.params.recreate(search, res.data, options, type);
                        return trainsFactory.fetchFlights(res.data, true);
                    })
                    .then(function() {
                        $state.go(cfg.resultsRoute);
                    });
            };

            fetchTop();
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-oneway-base-controller.js